import { useEffect } from 'react';

import { css } from '@compiled/react';

import { Column } from './column';
import { AnimationSteps } from './constants/ui';
import { useAnimatedJiraBoardStore } from './state';

const boardBodyStyle = css({
	borderRadius: '8px',
	overflowY: 'hidden',
});
const columnContainerStyle = css({
	display: 'flex',
	gap: '12px',
});

export const BoardBody = ({
	displayMode = 'animated',
	layoutMode,
}: {
	displayMode?: 'animated' | 'static';
	layoutMode?: 'legacy' | 'fixed-scene';
}) => {
	const [
		{ messages, todoCol, inProgressCol, doneCol, animationStep },
		{ transitionToInProgress, transitionToDone },
	] = useAnimatedJiraBoardStore();
	useEffect(() => {
		if (displayMode === 'static') return;
		switch (animationStep) {
			case AnimationSteps.IN_PROG_COL:
				transitionToInProgress();
				break;
			case AnimationSteps.DONE_COL:
				transitionToDone();
				break;
		}
	}, [animationStep, displayMode, transitionToInProgress, transitionToDone]);

	return (
		<div css={boardBodyStyle}>
			<div css={columnContainerStyle}>
				<Column
					layoutMode={layoutMode}
					displayMode={displayMode}
					title={messages.toDo}
					cards={todoCol}
				/>
				<Column
					layoutMode={layoutMode}
					displayMode={displayMode}
					title={messages.inProgress}
					cards={inProgressCol}
				/>
				<Column
					layoutMode={layoutMode}
					displayMode={displayMode}
					title={messages.done}
					cards={doneCol}
				/>
			</div>
		</div>
	);
};
